import React, { useContext, useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";
import { BiDish } from "react-icons/bi";
import {
  checkPermission,
  currencySymbolRight,
  currencySymbolLeft,
} from "../../../../../../functions/Functions";
import { RestaurantContext } from "../../../../../../contexts/Restaurant";
import { UserContext } from "../../../../../../contexts/User";

const RunningOrderModal = ({setEditOrder, editOrder}) => {
  const history = useHistory();
  const { runningOrders, setRunningOrders } = useContext(RestaurantContext);
  const { authUserInfo } = useContext(UserContext);
  const runningRef = useRef();

  useEffect(()=>{
    if(!editOrder) return;
    const onDocMouseDown = (e) => {
      // if click is outside the dropdown root, close
      if (e.target.closest('[data-ignore="true"]')) return;
      if (runningRef.current && !runningRef.current.contains(e.target)) {
        setEditOrder(false);
        setRunningOrders({ ...runningOrders, searchList: null });
      }
    };

    document.addEventListener("mousedown", onDocMouseDown);
    return () => {
      document.removeEventListener("mousedown", onDocMouseDown);
    };
  },[])

  const handleSearch = (e) => {
    let searchinput = e.target.value;
    if (searchinput.length === 0) {
      setRunningOrders({ ...runningOrders, searchList: null });
    } else {
      const deptFood = runningOrders.list?.filter((item) => {
        let lowerCaseTable = item?.table_name &&
          item.table_name.toLowerCase();
        return lowerCaseTable.includes(searchinput.toLowerCase());
      });
      setRunningOrders({
        ...runningOrders,
        searchList: deptFood,
      });
    }
  };
  
  return (
    <div ref={runningRef} className="pos--dropdown-list-edit">
      <div className="position-relative mx-2 mb-2">
        <i className="fa fa-search search-ruuning-order"></i>
        <input
          type="text"
          style={{padding: "0.1rem 0.1rem 0.1rem 1.6rem"}}
          className="form-control table-text"
          placeholder="Table search"
          onChange={(e) => handleSearch(e)}
        />
      </div>
      {(runningOrders?.searchList ?? runningOrders.list)?.map((item, index) => (
        <div
          key={index}
          className={`editOrderPos d-flex align-items-center justify-content-between mb-2 mx-2`}
          onClick={(e) => {
            e.preventDefault();
            if (
              authUserInfo.permissions !== null &&
              checkPermission(authUserInfo.permissions, "Order edit")
            ) {
              history.push("/dashboard/epos/" + item?.id, { fromUrl: true });
            }
          }}
        >
          <div className="p-1 sm-text" style={{ width: "80%" }}>
            <div className="editDetail">
              #{item.token?.id}
              {item && item.table_name !== "-" && (
                <span className="pl-0"> | Table : {item.table_name}</span>
              )}
            </div>
            <div className="editDetail mt-1">
              {item.order_type_name + " - " + item.party_name}
            </div>
            <div className="editOrderBranch mt-1 sm-text">
              {item?.branch_name}
              <span className="d-flex mt-1">
                <span className="editPrice">
                  {currencySymbolLeft()}
                  {item.total_payable}
                  {currencySymbolRight()}
                </span>
                {item?.waiter_name && item?.waiter_name !== "-" && (
                  <span className="editPrice rounded-sm text-truncate">
                    <BiDish className="edit_icon" />
                    {item?.waiter_name}
                  </span>
                )}
              </span>
            </div>
          </div>
          <div className="editIcon">
            <span className="mr-2">
              <i className="fa fa-pencil"></i>
            </span>
          </div>
        </div>
      ))}
    </div>
  );
};

export default RunningOrderModal;
